import { useQuery, useMutation } from "react-query";
import {
  fetchProductDetail,
  fetchShopDetail,
  fetchProductTrends,
  fetchProductSkus,
  fetchProductRelatedCreators,
  fetchProductRelatedVideos,
  fetchProductRelatedLives,
  fetchHomeFilterList,
} from ".";

export const useProductDetail = (productId: string) =>
  useQuery(["product-detail", productId], () => fetchProductDetail(productId), {
    enabled: !!productId,
  });

export const useShopDetail = (shopId: string) =>
  useQuery(["shop-detail", shopId], () => fetchShopDetail(shopId), {
    enabled: !!shopId,
  });

export const useProductTrends = (productId: string, dateType: string) =>
  useQuery(
    ["product-trends", productId, dateType],
    () => fetchProductTrends({ product_id: productId, date_type: dateType }),
    {
      enabled: !!productId,
    }
  );

export const useProductSkus = () => useMutation(fetchProductSkus);

export const useProductRelatedCreators = (productId: string) =>
  useQuery(
    ["product-related-creaters", productId],
    () =>
      fetchProductRelatedCreators({
        product_id: productId,
        page: 1,
        page_size: 10,
      }),
    {
      enabled: !!productId,
    }
  );

export const useProductRelatedVideos = (productId: string) =>
  useQuery(
    ["product-related-videos", productId],
    () =>
      fetchProductRelatedVideos({
        product_id: productId,
        page: 1,
        page_size: 10,
      }),
    {
      enabled: !!productId,
    }
  );

export const useProductRelatedLives = (productId: string) =>
  useQuery(
    ["product-related-lives", productId],
    () =>
      fetchProductRelatedLives({
        product_id: productId,
        page: 1,
        page_size: 10,
      }),
    {
      enabled: !!productId,
    }
  );

export const useHomeFilterList = () => useMutation(fetchHomeFilterList);
